const state = {
  files: [],
  removedIds: []
}

const getters = {

}

const actions = {
  addFiles({ commit }, payload) {
    commit('ADD_FILES', payload)
  },
  updateFiles({ commit }, payload) {
    commit('UPDATE_FILES', payload)
  },
  updateFile({ commit }, payload) {
    commit('UPDATE_FILE', payload)
  },
  setMainFile({ commit, dispatch }, fileId) {
    dispatch('unsetMainFile')

    commit('SET_MAIN_FILE', fileId)
  },
  unsetMainFile({ commit }) {
    commit('UNSET_MAIN_FILE')
  },
  removeFile({ commit }, fileId) {
    commit('REMOVE_FILE', fileId)
  },
  clearFiles({ commit }) {
    commit('CLEAR_FILES')
  }
}

const mutations = {
  ADD_FILES(state, payload) {
    // prepare and add initial files
    let newFiles = payload.files.map(file => {
      return {
        active: false,
        blob: file.path,
        data: {
          category: file.category,
          path: file.path,
          entity_type: file.entity_type,
          main: file.main
        },
        error: null,
        file: null,
        fileObject: true,
        headers: {},
        id: file.id,
        name: file.label || file.original_file,
        postAction: undefined,
        progress: '100.00',
        putAction: undefined,
        response: file,
        size: file.size,
        speed: 0,
        success: true,
        thumb: file.path,
        timeout: 0,
        type: file.type,
        dropzoneId: payload.dropzoneId
      }
    })

    // Remove existing files with the same dropzoneId before adding new ones
    const otherDropzoneFiles = state.files.filter(file => file.dropzoneId !== payload.dropzoneId)
    state.files = [...otherDropzoneFiles, ...newFiles]
  },
  UPDATE_FILES(state, payload) {
    for (let i = 0; i < payload.files.length; i++) {
      let file = payload.files[i]

      // set dropzoneId if not set
      if (file.dropzoneId !== payload.dropzoneId) {
        file.dropzoneId = payload.dropzoneId
      }

      let index = state.files.findIndex(f => f.id === file.id)

      // set state
      if (index > -1) {
        // update file
        state.files.splice(index, 1, file)
      } else {
        // new file added - ensure it's associated with the correct dropzoneId
        state.files = [...state.files, file]
      }
    }
  },
  UPDATE_FILE(state, payload) {
    const index = state.files.findIndex(file => file.id === payload.fileId)
    const file = state.files.find(file => file.id === payload.fileId)

    file.response = { ...file.response, ...payload.data }

    state.files.splice(index, 1, file)
  },
  UNSET_MAIN_FILE(state) {
    let mainFile = state.files.find(file => file.response.main === true)

    if (mainFile) {
      const index = state.files.findIndex(file => file.id === mainFile.id)

      mainFile.response.main = false
      state.files.splice(index, 1, mainFile)
    }
  },
  SET_MAIN_FILE(state, fileId) {
    const index = state.files.findIndex(file => file.id === fileId)
    const file = state.files.find(file => file.id === fileId)

    file.response = { ...file.response, main: true }

    state.files.splice(index, 1, file)
  },
  REMOVE_FILE(state, fileId) {
    const index = state.files.findIndex(file => file.id === fileId)
    const file = state.files[index]
    state.files.splice(index, 1)
    state.removedIds = [...state.removedIds, file.response.id]
  },
  CLEAR_FILES(state) {
    // restart state
    state.files = []
    state.removedIds = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
